import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../UI/card';
import { useLocale } from '../../contexts/LocaleContext';
import { getNodeTabByKey } from '../../config/tenantNodeTabsConfig';
import { themeClasses } from '../../config/themeClasses';
import TenantNodeDataTable from './TenantNodeDataTable';

function TenantNodeTabPanel({
  nodeKey,
  rows,
  loading,
  saving,
  onSaveNodeRows,
  onDirtyChange,
}) {
  const { t } = useLocale();
  const tab = getNodeTabByKey(nodeKey);

  if (!tab) return null;

  return (
    <Card className={themeClasses.appKit.sectionShell}>
      <CardHeader>
        <CardTitle>{t(tab.labelKey)}</CardTitle>
        <CardDescription>{t('tenantNodeTabDescription')}</CardDescription>
      </CardHeader>
      <CardContent>
        <TenantNodeDataTable
          nodeKey={nodeKey}
          rows={rows}
          loading={loading}
          saving={saving}
          onSaveRows={onSaveNodeRows}
          onDirtyChange={onDirtyChange}
        />
      </CardContent>
    </Card>
  );
}

export default TenantNodeTabPanel;
